import { render, staticRenderFns } from "./teamTextFields.vue?vue&type=template&id=160b34ae&scoped=true&"
import script from "./teamTextFields.vue?vue&type=script&lang=js&"
export * from "./teamTextFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b34ae",
  null
  
)

export default component.exports